import { useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import { AppShell } from './components/AppShell'
import { Login } from './pages/Login'
import { Dashboard } from './pages/Dashboard'
import { Queue } from './pages/Queue'
import { Personas } from './pages/Personas'
import { Compose } from './pages/Compose'
import { Settings } from './pages/Settings'
import { Manual } from './pages/Manual'
import { trackPage } from '../../family-design/analytics'

function Protected({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth()
  if (loading) {
    return (
      <div className="gm-shell flex h-screen items-center justify-center gap-2 text-sm text-ink-muted">
        <Loader2 size={16} className="text-primary motion-safe:animate-spin" aria-hidden /> 読み込み中…
      </div>
    )
  }
  if (!user) return <Navigate to="/login" replace />
  return <AppShell>{children}</AppShell>
}

/** ページ閲覧の計測（family-design/analytics.ts。URL の ID やクエリは伏せて送る） */
function PageTracker() {
  const { pathname } = useLocation()
  useEffect(() => { trackPage(pathname) }, [pathname])
  return null
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <PageTracker />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/queue" element={<Protected><Queue /></Protected>} />
          <Route path="/compose" element={<Protected><Compose /></Protected>} />
          <Route path="/personas" element={<Protected><Personas /></Protected>} />
          <Route path="/settings" element={<Protected><Settings /></Protected>} />
          <Route path="/manual" element={<Protected><Manual /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  )
}
